import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { Button, rem, Spacer } from 'design-system';
import Modal from 'utils/packages/Modal';
import Text from 'design-system/Text';
import { Tier } from 'features/premium/entities';
import { formatAmount } from 'utils/formatting';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { UpgradeWebModal } from 'design-system/UpgradeWebModal';
import { isWeb } from '../../../constants';
import { selectAutoInvestFee } from '../reducers/selectors';
const AutoInvestFeeInfoModalContent = ({ fee, hideUpgrade }) => {
    const navigation = useMainStackNavigation();
    const currentFee = useAppSelector(selectAutoInvestFee);
    const autoInvestTierFees = useAppSelector((state) => state.invest.autoInvestTierFees);
    const feeOnFree = autoInvestTierFees?.[Tier.free];
    const feesStr = formatAmount(fee.value, fee.currency, 2);
    const onClose = useCallback(() => {
        Modal.hide();
    }, []);
    const upgrade = useCallback(() => {
        Modal.hide(() => {
            if (isWeb) {
                UpgradeWebModal.show(undefined);
                return;
            }
            navigation.navigateDeprecated('EmmaProModal', {});
        });
    }, []);
    return (<View style={styles.modalContainer}>
      <Spacer h={16}/>
      {fee.value ? (<Text TextThin-14 Secondary centered>
          A{' '}
          <Text NumbersThin-14 Secondary>
            {feesStr}
          </Text>{' '}
          fee is applied to each Autoinvest. This fee is waived for users subscribed to Emma Plus, Pro and Ultimate.
        </Text>) : (<Text TextThin-14 Secondary centered>
          As an Emma premium member, you enjoy free Autoinvest. We’ve waived the standard
          {feeOnFree ? ` ${formatAmount(feeOnFree, 'GBP', 2)}` : ''} fee for you.
        </Text>)}
      <Spacer h={32}/>
      {currentFee && !hideUpgrade ? (<>
          <Button brandReversed title={'View all plans'} onPress={upgrade}/>
          <Spacer h={8}/>
        </>) : null}
      <Button brand title="Okay" onPress={onClose}/>
    </View>);
};
const AutoInvestFeeInfoModal = {
    show: (fee, hideUpgrade) => {
        Modal.show(<AutoInvestFeeInfoModalContent fee={fee} hideUpgrade={hideUpgrade}/>, {
            containerStyle: styles.modal,
            title: 'Autoinvest fee',
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    modalContainer: {
        paddingHorizontal: rem(16),
    },
});
export default AutoInvestFeeInfoModal;
